import angular from 'angular';
import simulatedComponent from './simulated.component';

let simulatedModule = angular.module('simulated', [])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('simulated', {
      url: '/cms/preview/username/:username/token/:token/uoid/:uoid',
      component: 'simulated'
    });
})
.component('simulated', simulatedComponent)

.name;

export default simulatedModule;



// WEBPACK FOOTER //
// ./client/app/pages/simulated/simulated.js